<template>
  <div class="company">
    <div
      class="companyInfo"
      v-if="item !== null && typeof item !== 'undefined'"
    >
      <div class="company-logo">
        <img
          class="logo"
          :src="
            item.information !== 'undefined' && item.information !== null
              ? item.information.company_logo
              : ''
          "
          v-if="
            item.information !== null &&
            item.information !== '' &&
            item.information.company_logo !== null
          "
        />
        <img
          class="logo"
          :src="companyNoImage"
          alt="No thumnail of company"
          v-else
        />
        <h3>
          {{ getCompanyName }}
        </h3>
      </div>
      <div class="content-container">
        <p class="content">
          {{
            item.information !== 'undefined' && item.information !== null
              ? item.information.business_content
              : ''
          }}
        </p>
      </div>
      <div class="note-container">
        <div class="note">
          <v-btn class="button" icon color="#e8320e">
            <v-icon class="icon">mdi-clipboard-text</v-icon>
          </v-btn>
          <p class="office-location">
            {{
              item.information !== null && item.information !== 'undefined'
                ? industryTypeFormatLandingPage(item.information.industry_type)
                : ''
            }}
          </p>
        </div>

        <div class="note">
          <v-btn class="button" icon color="#e8320e">
            <v-icon class="icon">mdi-map-marker</v-icon>
          </v-btn>
          <div class="office-location">
            {{
              typeof item.information !== 'undefined' &&
              item.information !== null
                ? workLocationFormat(
                    item.information.job_description !== null &&
                      item.information.job_description.work_location !== null
                      ? item.information.job_description.work_location
                      : null
                  )
                : ''
            }}
          </div>
        </div>
      </div>
    </div>

    <img
      :src="
        item.information !== 'undefined' && item.information !== null
          ? item.information.thumbnail
          : ''
      "
      alt="company"
      v-if="
        item.information !== null &&
        item.information !== '' &&
        item.information.thumbnail !== null
      "
    /><img :src="companyNoImage" alt="No thumnail of company" v-else />
  </div>
</template>

<script>
import CompanyNoImage from '@/assets/image/company-no-image.jpg';
import { mapGetters } from 'vuex';
import { masterMixin } from '@/mixins/masterMixin.js';
export default {
  mixins: [masterMixin],
  data() {
    return {
      companyNoImage: CompanyNoImage
    };
  },
  computed: {
    ...mapGetters({
      landingPageLink: 'getLandingPageLink',
      mIndustryTypeLandingPage: 'getMIndustryTypeLandingPage',
      MWorkLocationCompanyLandingPage: 'getMWorkLocationLandingPage'
    }),
    getCompanyName() {
      if (
        this.item.information !== null &&
        this.item.information.complete_flag === 1
      ) {
        return this.item.information !== null
          ? this.item.information.company_name
          : '';
      } else {
        return this.item !== null ? this.item.company_name : '';
      }
    }
  },
  props: {
    item: {
      type: Object
    }
  },
  methods: {
    industryTypeFormatLandingPage: function (id) {
      const arr = this.mIndustryTypeLandingPage.filter((ele) => ele.id === id);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },
    workLocationFormat: function (workLocationArr = '[]') {
      let stringWorkLocation = '';

      const workLocation = this.MWorkLocationCompanyLandingPage;

      const workLocationId =
        workLocationArr !== null && workLocationArr !== ''
          ? JSON.parse(workLocationArr)
          : [];
      // console.log(workLocationId);
      if (workLocationId.length > 0 && typeof workLocationId !== 'undefined') {
        workLocation.map((ele) => {
          // console.log(ele);
          workLocationId.forEach((item, index) => {
            if (item == ele.id) {
              stringWorkLocation += ele.name_convert;
              stringWorkLocation +=
                index < workLocationId.length - 1 ? ', ' : '';
            }
          });
        });
      }
      return stringWorkLocation;
    }
  },
  watch: {},

  created() {}
};
</script>

<style lang="scss">
@import './landingPage.scss';
</style>
